<div class="configs-container">
  <!-- Selector de clientes + botón generar -->
  <div class="selector-row">
    <div class="selector-wrapper">
      <label class="field-label">{{ titulo }}</label>
      <app-cliente-selector
        [formControl]="clientesSelectorControl"
        [idClienteFinal]="idClienteFinal"
        [multiple]="true"
      ></app-cliente-selector>
    </div>
  </div>

  <!-- Horarios por cliente: desplegable, sólo si hay clientes elegidos -->
  @if (clientesSelectorControl.value?.length) {
    <mat-expansion-panel
      class="horarios-panel"
      [expanded]="showCards"
      [disabled]="disabled"
      (opened)="generar()"
      (closed)="showCards = false"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon>schedule</mat-icon>
          Horarios de atención
        </mat-panel-title>
        <mat-panel-description>{{ resumenHorarios }}</mat-panel-description>
      </mat-expansion-panel-header>

      @if (configsArray.controls.length) {
        <div class="configs-scroll-container">
          @for (grupo of configsArray.controls; track $index) {
            <mat-card class="config-card" [formGroup]="grupo">
              <div class="config-header">
                <span class="config-numero">Horario {{ $index + 1 }}</span>
                <button
                  irxBotonIcono
                  tono="peligro"
                  type="button"
                  (click)="eliminar($index)"
                  [disabled]="disabled"
                  tooltip="Eliminar"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>

              <div class="config-content">
                <!-- Cliente (solo lectura, seleccionado arriba) -->
                <div class="full-width">
                  <app-cliente-selector
                    [formControl]="displayControls[$index]"
                    [idClienteFinal]="idClienteFinal"
                    [multiple]="false"
                  ></app-cliente-selector>
                </div>

                <!-- Días -->
                <ng-select
                  class="full-width"
                  formControlName="dias"
                  [items]="diasSemana"
                  bindLabel="label"
                  bindValue="valor"
                  [multiple]="true"
                  [closeOnSelect]="false"
                  placeholder="Días (vacío = todos)"
                  notFoundText="Sin resultados"
                  appendTo="body"
                  (blur)="onBlur()"
                ></ng-select>

                <!-- Horarios -->
                <div class="horarios-group">
                  <app-time-picker
                    class="horario-field"
                    formControlName="horaInicio"
                    label="Desde"
                    placeholder="HH:mm"
                    (focusout)="onBlur()"
                  ></app-time-picker>

                  <app-time-picker
                    class="horario-field"
                    formControlName="horaFin"
                    label="Hasta"
                    placeholder="HH:mm"
                    (focusout)="onBlur()"
                  ></app-time-picker>
                </div>
              </div>
            </mat-card>
          }
        </div>
      }
    </mat-expansion-panel>
  }
</div>
